import React, { useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDebounceValue } from 'usehooks-ts';
import { useGetCompanies } from '~/hooks/companies';
import { downloadCompaniesUsers } from '~/utils';
import InputSearch from '~/components/InputSearch';
import Pagination from '~/components/Pagination';
import MagasinsTable from '~/components/table/MagasinsTable';
import styles from './list-magasins.module.scss';
import ButtonExport from '~/components/ButtonExport';
import FilterSearchParam from '~/components/FilterSearchParam';
import { useAccountsList } from '~/hooks/account';

const ListMagasins = () => {
  type PaginationHandle = React.ElementRef<typeof Pagination>;
  const paginationRef = useRef<PaginationHandle>(null);

  const [searchParams, setSearchParams] = useSearchParams();
  const { search = '', ...paramsObject } = Object.fromEntries(searchParams);
  const [debouncedSearch] = useDebounceValue(search, 500);
  const {
    data: list,
  } = useAccountsList({
    type: 'magasin',
  });
  const {
    signs = [],
  } = list;
  const { data: dataCompanies = {} } = useGetCompanies({
    ...paramsObject,
    search: debouncedSearch,
    type: 'magasin',
  });
  const { companies: magasins = [], meta = {} } = dataCompanies;

  const handleSorting = (sort: any) => {
    if (!sort) return;
    const params = new URLSearchParams(searchParams);
    params.set('sortKey', sort.id.replace('_', '.'));
    params.set('order', sort.desc ? 'desc' : 'asc');
    setSearchParams(new URLSearchParams(params));
  };

  const handleSearch = (searchValue: string) => {
    const params = new URLSearchParams(searchParams);
    if (searchValue.length < 3) {
      params.delete('search');
    } else {
      params.set('search', searchValue);
    }
    if (searchValue.length >= 3) {
      params.set('page', '1');
      paginationRef.current?.setPage(1);
    }
    setSearchParams(params);
  };

  const handleChangePage = (page: number) => {
    const params = new URLSearchParams(searchParams);
    params.set('page', page.toString());
    setSearchParams(params);
  };

  console.log(list);

  return (
    <>
      <div className={styles.header}>
        <div>
          <h1>{meta?.total} Magasin{meta?.total > 1 && 's'}</h1>
          <div className={styles.filters}>
            <div className={styles.field}>
              <FilterSearchParam
                label='Enseigne'
                name='sign'
                feminine
                options={signs}
              />
            </div>
            <div className={styles.field}>
              <InputSearch
                defaultValue={search}
                handleSearch={handleSearch}
              />
            </div>
          </div>
        </div>
        <div className={styles.actions}>
          <ButtonExport type='export' onClick={() => downloadCompaniesUsers('magasin', {
            ...paramsObject,
            search,
          })} />
        </div>
      </div>
      {(magasins) && (
        <div className={styles.containerList}>
          <div className={styles.list}>
            <MagasinsTable
              companies={magasins}
              handleSorting={handleSorting}
            />
          </div>
          <div className={styles.footer}>
            {meta.total > 0 && <Pagination
              ref={paginationRef}
              pages={meta?.pages || 0}
              defaultPage={parseInt(searchParams.get('page') || '1', 10)}
              handleChange={handleChangePage}
            />}
          </div>
        </div>
      )}
    </>
  );
};

export default ListMagasins;
